import { validateLuhn } from "./numbersManipulation";
import i18n from "@/i18n/wrappers/i18n";

const t = i18n.global.t;

export function checkPrePaidCardNumber(value, prefixes) {
  const cleanedValue = value.replace(/\D/g, "");
  const validateCode = Object.values(prefixes).some((prefix) =>
    cleanedValue.startsWith(prefix)
  );

  const validateLength = value.length == 19;
  return (
    (validateLuhn(value) && validateCode && validateLength) ||
    t("validations.numbers_manipulations.invalid_number_card")
  );
}

export const emailMatchValidation = (value, currentValue, field) => {
  const validateEmail = /\S+@\S+\.\S+/;

  return (
    (validateEmail.test(value) && value === currentValue) ||
    t(
      `validations.string_manipulations.${
        value ? "unmatched_field" : "required_field"
      }`,
      { field: field }
    )
  );
};


/**
 * Validação de username do instagram.  
 * Permite apenas A-Z, 0-9, ponto e underline
 * - Retorna true se o username for inválido
 * - Retorna false se o username for válido
 * 
 * @param {string} value
 * @returns {boolean}
 * */
export const instagramUsernameInvalid = (value) => {
  return /[^a-zA-Z0-9._]/.test(value)
}

export const celularInvalid = (value) => {
  if ( value.length > 4 && value[5] != 9 ) {
    return t("forms.validation.custom.celularInvalid")
  }

  if ( value.length < 15 ) {
    return t("forms.validation.custom.celularIncomplete")
  }
}